import {
  Client,
  Order,
  OrderClientFieldConfig,
  OrderDetailFieldVisibility,
} from "types";

const normalizeClientName = (client?: Client | null) =>
  (client?.razon_social ?? "").trim().toUpperCase();

const buildDetailConfig = (
  overrides: Partial<OrderDetailFieldVisibility> = {},
): OrderDetailFieldVisibility => ({
  showLote: true,
  showOc: false,
  showFechaVencimiento: false,
  showPeso: true,
  ...overrides,
});

export const getOrderClientFieldConfig = (
  client?: Client | null,
): OrderClientFieldConfig => {
  const clientName = normalizeClientName(client);

  if (clientName === "PETRONAS LUBRICANTES") {
    return {
      detail: buildDetailConfig(),
    };
  }

  if (clientName === "PRESMAR SA") {
    return {
      detail: buildDetailConfig(),
    };
  }

  if (clientName.includes("SEALED")) {
    return {
      detail: buildDetailConfig({
        showOc: true,
      }),
    };
  }

  if (clientName === "MICRO CONTROL SA") {
    return {
      detail: buildDetailConfig({
        showOc: true,
      }),
    };
  }

  if (clientName === "PAMPA TRADE SA") {
    return {
      detail: buildDetailConfig({
        showFechaVencimiento: true,
      }),
    };
  }

  if (clientName.includes("GCP")) {
    return {
      detail: buildDetailConfig({
        showOc: true,
      }),
    };
  }

  if (clientName === "ADAMANT SRL") {
    return {
      detail: buildDetailConfig({
        showLote: false,
        showOc: false,
        showFechaVencimiento: false,
      }),
    };
  }

  return {
    detail: buildDetailConfig({
      showLote: client?.show_lote ?? true,
      showOc: client?.show_oc ?? true,
      showFechaVencimiento: client?.show_fecha_vencimiento ?? true,
    }),
  };
};

export const getCombinedOrderClientFieldConfig = (
  orders: Order[],
): OrderClientFieldConfig =>
  orders.reduce<OrderClientFieldConfig>(
    (combinedConfig, order) => {
      const currentConfig = getOrderClientFieldConfig(order.client ?? null);

      return {
        detail: {
          showLote:
            combinedConfig.detail.showLote || currentConfig.detail.showLote,
          showOc: combinedConfig.detail.showOc || currentConfig.detail.showOc,
          showFechaVencimiento:
            combinedConfig.detail.showFechaVencimiento ||
            currentConfig.detail.showFechaVencimiento,
          showPeso: combinedConfig.detail.showPeso || currentConfig.detail.showPeso,
        },
      };
    },
    {
      detail: {
        showLote: false,
        showOc: false,
        showFechaVencimiento: false,
        showPeso: false,
      },
    },
  );
